import dynamic from 'next/dynamic';
import cx from 'classnames';

import styles from './index.module.scss';

const Typography = dynamic(import('#app/UI/atoms/new-typography'));
const ClassIcon = dynamic(() => import('./icons').then(module => module.ClassIcon));
const DesktopIcon = dynamic(() => import('./icons').then(module => module.DesktopIcon));
const ImageIcon = dynamic(() => import('./icons').then(module => module.ImageIcon));
const ToolsIcon = dynamic(() => import('./icons').then(module => module.ToolsIcon));

const list = [
  {
    icon: <DesktopIcon />,
    text: 'Diversión asegurada en clases 100% en vivo y desde casa',
    background: '#E4FFFC'
  },
  {
    icon: <ToolsIcon />,
    text: 'Desarrollarán su pensamiento lógico y creatividad',
    background: '#E7F7FF'
  },
  {
    icon: <ClassIcon />,
    text: 'Mejorarán su rendimiento en la escuela',
    background: '#F6E8FF'
  },
  {
    icon: <ImageIcon />,
    text: 'Impulsa el talento de tus hijos con nuestros cursos',
    background: '#FFEDE3'
  }
];

const Card = ({ icon, text, background }) => (
  <li className={styles.card} style={{ background }}>
    <div className={styles.icon}>{icon}</div>

    <Typography className="typo-12 mt-12" tag="p">
      {text}
    </Typography>
  </li>
);

const Hero = () => {
  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <Typography className="typo-56 rockone" tag="h2">
          ¿Sabías que para el 2030 <br /> al mundo le{' '}
          <span style={{ color: '#047DEC' }}>
            faltarán más de 85.2 millones de programadores?
          </span>
        </Typography>

        <Typography className="typo-20" tag="p">
          ¡En Crack The Code lo sabemos! Nuestros cursos y rutas están diseñados para
          preparar a tu hij@ y que aproveche las oportunidades del futuro.
        </Typography>

        <ul className={cx(styles.list, 'flex')}>
          {list.map((item, idx) => (
            <Card idx={idx} {...item} />
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Hero;
